module.exports = __webpack_public_path__ + "static/img/t18.0e050c55.png";